import React from 'react';
import './MaintenancePage.css';

/**
 * Full-screen maintenance page shown when REACT_APP_MAINTENANCE_MODE=true.
 * Toggle maintenance by setting the env var and rebuilding, or use a runtime
 * check if you add a /api/maintenance-status endpoint later.
 */
function MaintenancePage() {
  const message = process.env.REACT_APP_MAINTENANCE_MESSAGE || 
    'We are currently performing scheduled maintenance to improve your experience.';
  const estimatedTime = process.env.REACT_APP_MAINTENANCE_ETA || 
    'We\'ll be back soon.';

  return (
    <div className="maintenance-page" role="main" aria-live="polite">
      <div className="maintenance-page__card">
        <div className="maintenance-page__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </div>
        <h1 className="maintenance-page__title">Under Maintenance</h1>
        <p className="maintenance-page__message">{message}</p>
        <p className="maintenance-page__eta">{estimatedTime}</p>
        <div className="maintenance-page__brand">
          <span className="maintenance-page__brand-name">The Monarch Insurance Company</span>
        </div>
      </div>
    </div>
  );
}

export default MaintenancePage;
